import HomeCard from "./homeCard";
import PopUpFormFeedback from "../../../popUpForms/popUpFormFeedback";

const CardShareFeedback = ({ hoveredTab, onTabHover, onTabLeave }) => {
  return (
    <HomeCard
      hoveredTab={hoveredTab}
      onTabHover={onTabHover}
      onTabLeave={onTabLeave}
      id="feedback"
      title="Share Feedback & Upload Your Scorecard"
      titleColor="var(--green)"
      popUpComponent={<PopUpFormFeedback />}
      content={[
        {
          type: "header-H5",
          color: "var(--gold)",
          text: "Support Creation of Global Best Practices",
        },
        {
          type: "paragraph",
          color: "var(--white)",
          text: "Help us improve the scorecard by sending feedback, collaborating, and sharing learnings or best practices to accelerate our progress.",
        },
        {
          type: "paragraph",
          color: "var(--white)",
          text: "Upload your community’s scorecard results.",
        },
        {
          type: "paragraph",
          color: "var(--white)",
          text: "Any feedback or suggestions are welcome, whether it is for the website, scorecard, processes, or wildfires in general.",
        },
        { type: "button", text: "Feedback & Upload", color: "var(--green)" },
      ]}
    />
  );
};

export default CardShareFeedback;
